<template>
    <Teleport to="#gift-voucher-payment-method-vue-app">
        <div id="gift-voucher-payment-method">
            <CheckDtVoucherForm ref="check-voucher-form"
                                btn-color="default"
                                @selected="onVoucherSelected" />

            <!-- Button to use the voucher, if possible. -->
            <div v-if="soldGiftVoucher"
                 class="mt-1 text-right">
                <button :disabled="!soldGiftVoucher.isRedeemable"
                        type="submit"
                        class="btn btn-xl btn-primary"
                        @click.prevent="useVoucher">
                    {{ l('PAYMENT.USE_VOUCHER') }}
                </button>
            </div>
        </div>
    </Teleport>
</template>

<script>
import CheckDtVoucherForm from '@/epos/vue/modals/Search/CheckDtVoucherForm';
import EventNames from '@/lib/Events/EventNames';
import { cloneDeep } from '@/functions/clone';
import { container } from '@/container';

export default {
    name: 'GiftVoucherPaymentMethod',

    components: { CheckDtVoucherForm },

    data() {
        return {
            soldGiftVoucher: null,
        };
    },

    methods: {
        onVoucherSelected(value) {
            this.soldGiftVoucher = value;
        },

        useVoucher() {
            if (this.soldGiftVoucher) {
                // Notify the Angular Controller that we want to use the gift voucher.
                try {
                    container.eventBus.broadcast(
                        EventNames.GIFT_VOUCHER_SELECTED_FOR_USE,
                        cloneDeep(this.soldGiftVoucher)
                    );
                } catch (error) {
                    // Error thrown by Angular $broadcast() that doesn't seem to have any effect. So suppress the error
                    // but log it. Any other errors are not expected to rethrow.
                    if (error.message.includes('$$nextSibling') || error.message.includes('current is null')) {
                        console.warn(error);
                    } else {
                        throw error;
                    }
                }
                this.$refs['check-voucher-form'].reset();
                this.soldGiftVoucher = null;
            }
        },
    },
};
</script>
